// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1___040c330110e19240c00","cls2":"PaperContainer-cls2___a1e4e88cd5cc3e00ad6 PaperContainer-cls1___040c330110e19240c00"};